import { render, staticRenderFns } from "./ProjectComming.vue?vue&type=template&id=7eaffff1&scoped=true"
import script from "./ProjectComming.vue?vue&type=script&lang=js"
export * from "./ProjectComming.vue?vue&type=script&lang=js"
import style0 from "./ProjectComming.vue?vue&type=style&index=0&id=7eaffff1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7eaffff1",
  null
  
)

export default component.exports